export const defaultGeolocation = {
	radius: 10,
	centerPoint: {
		latitude: 52.377956,
		longitude: 4.89707
	}
}
